import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BETextileCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Textile Engineering",
    shortName: "B.E. Textile",
    duration: "4 years",
    description: "Engineering program focused on textile manufacturing, fiber science, and fabric technology",
    overview: "Bachelor of Engineering in Textile Engineering (B.E. Textile) is a 4-year undergraduate program that covers all aspects of textile manufacturing from fiber production to finished fabric processing. This course includes fiber science, yarn manufacturing, fabric construction, dyeing and finishing, and textile machinery, preparing students for careers in the textile and apparel industry.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Interest in materials and manufacturing processes"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Introduction to Textile Engineering",
          "Fiber Science"
        ]
      },
      {
        year: 2,
        subjects: [
          "Yarn Manufacturing Technology",
          "Textile Materials",
          "Textile Machinery",
          "Fluid Mechanics",
          "Heat and Mass Transfer",
          "Textile Chemistry"
        ]
      },
      {
        year: 3,
        subjects: [
          "Fabric Manufacturing (Weaving)",
          "Knitting Technology",
          "Textile Wet Processing",
          "Dyeing and Printing",
          "Textile Testing and Quality Control",
          "Nonwoven Technology"
        ]
      },
      {
        year: 4,
        subjects: [
          "Apparel Manufacturing",
          "Technical Textiles",
          "Textile Management",
          "Environmental Aspects",
          "Project Work",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Textile Engineer",
        "Production Manager",
        "Quality Control Engineer",
        "Research and Development Engineer",
        "Textile Designer",
        "Process Engineer",
        "Technical Textile Engineer",
        "Export Manager",
        "Merchandiser",
        "Plant Manager"
      ],
      industries: [
        "Textile Manufacturing",
        "Apparel and Garment Industry",
        "Technical Textiles",
        "Spinning Mills",
        "Dyeing and Processing Units",
        "Textile Machinery Manufacturing",
        "Export Houses",
        "Fashion and Design Industry",
        "Research and Development",
        "Government Textile Organizations"
      ],
      averageSalary: "₹4-8 LPA (Fresher), ₹12-30 LPA (Experienced)",
      topRecruiters: [
        "Arvind Mills, Welspun",
        "Raymond, Vardhman Textiles",
        "Aditya Birla Fashion",
        "Reliance Industries",
        "Trident Group, Alok Industries",
        "Textile Export Companies"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "PSG College of Technology",
        location: "Coimbatore",
        fees: "₹4,50,000",
        ranking: "NIRF Ranking: 42"
      },
      {
        name: "Kumaraguru College of Technology",
        location: "Coimbatore",
        fees: "₹4,00,000",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "Anna University (CEG)",
        location: "Chennai",
        fees: "₹2,00,000",
        ranking: "NIRF Ranking: 35"
      },
      {
        name: "The South India Textile Research Association",
        location: "Coimbatore",
        fees: "₹3,50,000",
        ranking: "Industry-Affiliated"
      }
    ],

    skills: [
      "Textile Manufacturing Processes",
      "Quality Control and Testing",
      "CAD for Textile Design",
      "Process Optimization",
      "Textile Chemistry",
      "Machinery Operation and Maintenance",
      "Supply Chain Management",
      "Export-Import Procedures",
      "Sustainability in Textiles",
      "Project Management"
    ],

    futureScope: "Growing prospects with technical textiles expansion, sustainable fashion trends, smart textiles development, and India's position as a global textile manufacturing hub.",

    faqs: [
      {
        question: "What are technical textiles?",
        answer: "Technical textiles are specialized fabrics used in industries like automotive, medical, aerospace, and construction rather than traditional clothing applications - a rapidly growing sector."
      },
      {
        question: "Are there opportunities in fashion industry?",
        answer: "Yes, textile engineers work in fashion companies for fabric development, quality control, production planning, and sustainable fashion initiatives."
      },
      {
        question: "What about export opportunities?",
        answer: "India is a major textile exporter. Many opportunities exist in export houses, international brands, and global textile companies for quality assurance and production management."
      },
      {
        question: "Is the textile industry sustainable?",
        answer: "The industry is rapidly adopting sustainable practices. There's growing demand for engineers skilled in eco-friendly processes, recycling, and sustainable manufacturing."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BETextileCoursePage;
